import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Hayder Atiyah</span> from{" "}
            <span className="purple">Virginia, USA</span>.
            <br />I am a <span className="purple">
              React Developer
            </span> and <span className="purple">Front-End Specialist</span>.
            <br />
            I graduated with a CS degree from George Mason University.
            <br />I also completed the{" "}
            <span className="purple">
              Meta Front-End Developer Certificate
            </span>{" "}
            (
            <a
              href="https://www.coursera.org/account/accomplishments/professional-cert/NCX8WQO6EGBR"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#8f6cd6", textDecoration: "underline" }}
            >
              see certificate
            </a>
            ).
            <br />
            <br />
            Besides coding, I love doing other things too!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Video Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Driving & Exploring New Places
            </li>
            <li className="about-activity">
              <ImPointRight /> Learning Spanish
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Build web experiences that are fast, beautiful, and impactful."
          </p>
          <footer className="blockquote-footer">Hayder Atiyah</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
